import { render, staticRenderFns } from "./IdealTaskHeat.vue?vue&type=template&id=6e77f3a7&scoped=true"
import script from "./IdealTaskHeat.vue?vue&type=script&lang=js"
export * from "./IdealTaskHeat.vue?vue&type=script&lang=js"
import style0 from "./IdealTaskHeat.vue?vue&type=style&index=0&id=6e77f3a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77f3a7",
  null
  
)

export default component.exports